module.exports = __webpack_public_path__ + "static/media/patrolCar.85a5d73c.jpg";